import React from 'react'
import Main from '../Components/UpdatePasswordComp/Main'

const ChangePassword = () => {
  return (
    <>
      <Main/>
    </>
  )
}

export default ChangePassword
